module.exports = require('./components/toonsdk').default;
